import React, { MouseEvent } from "react";

interface ICheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    indeterminate?: boolean;
    fancy?: boolean;
    fancySize?: "small" | "normal" | "large";
    fancyStyle?: "filled" | "mark" | "stacked";
    includeLabel?: boolean;
    stopClick?: boolean;
}

class Checkbox extends React.Component<ICheckboxProps> {
    private elementRef: React.RefObject<HTMLInputElement>;

    constructor(props: Readonly<ICheckboxProps>) {
        super(props);

        this.elementRef = React.createRef();
    }

    public componentDidMount() {
        if (this.props.indeterminate !== undefined && this.elementRef.current) {
            this.elementRef.current.indeterminate = this.props.indeterminate;
        }
    }

    public componentDidUpdate(prevProps: Readonly<ICheckboxProps>) {
        if (prevProps.indeterminate !== this.props.indeterminate && this.props.indeterminate !== undefined && this.elementRef.current) {
            this.elementRef.current.indeterminate = this.props.indeterminate;
        }
    }

    public render() {
        const { indeterminate, type, fancy, fancyStyle, fancySize, children, stopClick, className, includeLabel, ...props } = this.props;

        const clickHandler = stopClick
                ? this.stopProp
                : undefined;

        if (fancy) {
            if (!props.id) {
                throw new Error("Id prop must be set");
            }

            const classNames = ["checkbox"];
            if (className) {
                classNames.push(className);
            }

            switch (fancySize) {
                case "small":
                    classNames.push("cb-small");
                    break;
                default:
                case "normal":
                    classNames.push("cb-normal");
                    break;
                case "large":
                    classNames.push("cb-large");
                    break;
            }

            switch (fancyStyle) {
                case "filled":
                    classNames.push("cb-filled");
                    break;
                case "stacked":
                    classNames.push("cb-stacked");
                    break;
                default:
                case "mark":
                    classNames.push("cb-mark");
                    break;
            }

            return <span className={classNames.join(" ")}>
                <input ref={this.elementRef} type={type === "radio" ? "radio" : "checkbox"} {...props} />
                <label htmlFor={`${props.id}`} onClick={clickHandler}>{children}</label>
            </span>
        }
        else if (includeLabel) {
            return <span>
                <input ref={this.elementRef} type={type === "radio" ? "radio" : "checkbox"} className={className} onClick={clickHandler} {...props} />
                <label htmlFor={props.id}>{children}</label>
            </span>;
        }
        else {
            return <input ref={this.elementRef} type={type === "radio" ? "radio" : "checkbox"} className={className} onClick={clickHandler} {...props} />;
        }
    }

    private stopProp(e: MouseEvent<HTMLInputElement | HTMLLabelElement>) {
        e.stopPropagation();
    }
}

export default Checkbox;
